import { isWizard } from './isWizard';

export enum SessionType {
  unknown,
  unauthenticated,
  advisor,
  client,
  wizard, // Waterlily Support & Developers
  scheduledEvent, // Scheduled events from event bridge that use api key
  docusignWebhook, // DocuSign webhook requests with Basic Auth
  duplicateAccount,
  // Conversational operations API (/api/conversation/v1). A server-to-server caller
  // (Intercom) acting on behalf of one verified advisor. Deliberately NOT scheduledEvent:
  // assertClientOwnership grants that type blanket access to every client, which would be a
  // cross-tenant leak here. New members must be appended, never inserted — the numeric
  // values are compared across package boundaries.
  conversation,
}

export const allSessionTypes = [
  SessionType.unknown,
  SessionType.unauthenticated,
  SessionType.advisor,
  SessionType.client,
  SessionType.wizard,
  SessionType.scheduledEvent,
  SessionType.docusignWebhook,
  SessionType.duplicateAccount,
  SessionType.conversation,
];

/**
 * Returns the appropriate session type for a given user. "User" since in the future
 * we'll have other user types even though right now all are advisor-based.
 */
export function sessionTypeForUser(advisor: Advisor) {
  return isWizard(advisor) ? SessionType.wizard : SessionType.advisor;
}
